module.exports = __webpack_public_path__ + "img/line-height.ab5be728.svg";